/* globals $:false */

import utils from '@cob/ui-genesis/cob.utils.js';

// args:
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A string space separated with a list of css classes to add to the input
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value
//
// * `timeFormat`: the date format. Defaults to 'hh:mm'
//
var Time = function(core, confs) {

    var _$input,
        _lastValue;

    var _confs = {
        id: core.locallyUniqueId(),
        fieldDefinition: {name: ""},
        cssClasses: undefined,
        readonly: false,
        valueChanged: undefined,

        lang: core.getLanguage(),
        format: 'H:i',
        datepicker: false,
        step: 30,
        scrollInput: false
    };

    utils.extend(_confs, confs, true);

    var _setValue = function(value) {
        // We just want to notify
        // when the value changes.
        if (_lastValue !== value) {
            _lastValue = value;

            if (_confs.valueChanged) {
                _confs.valueChanged(value);
            }
        }
    };

    var _onValueChange = function() {
        var value = _$input.val();

        if (value.trim().length > 0) {
            _setValue(value);

        } else {
            _setValue(undefined);
        }
    };

    var _render = function() {
        var $html = $([
            '<div class="inline">',
            '<input id="f' + _confs.id + '" class="field-value cob-field-value time-field" type="text"  placeholder="' + _confs.fieldDefinition.name + '">',
            '</div>'
        ].join(''));

        _$input = $html.find("input");

        if (_confs.cssClasses) {
            _$input.addClass(_confs.cssClasses);
        }

        if (_confs.readonly) {
            _$input.attr("readonly", "readonly").attr("tabindex", -1);
        } else {
            _$input = _$input.datetimepicker(_confs);
            _$input.on('keydown paste blur change', _onValueChange);
        }

        if (_lastValue) {
            _$input.val(_lastValue);
        }

        return $html;
    };

    var _clearError = function() {
        _$input.removeClass("error");
    };

    var _showError = function() {
        _$input.addClass("error");
    };

    var _destroy = function() {
        if (!_confs.readonly) {
            _$input.datetimepicker('destroy');
            _$input.off('keydown paste blur change', _onValueChange);
        }
    };

    return {
        render: _render,
        destroy: _destroy,

        clearError: _clearError,
        showError: _showError,

        setValue: function(value) {
            if (_$input) {
                _$input.val(value);
            }

            // Notify that this field has a new value because
            // I want to update the $auto.join and other fields...
            _setValue(value);
        },
        getValue: function() {
            return _lastValue ? String(_lastValue) : undefined;
        },

        disableSelf: function() {
            _$input.attr("readonly", "readonly").attr("tabindex", -1);
            _$input.datetimepicker('destroy')
        }
    }
};

export default Time;
